import {
  IconButton,
  Menu,
  MenuItem,
  Typography,
  Box,
  PopoverOrigin,
  SxProps,
  Theme,
} from '@mui/material';
import React from 'react';
import genericClasses from '../../../theme/GenericClasses';
import classes from './style';

interface ICustomMenuList {
  id?: string;
  items: Array<ICustomMenuItem>;
  disableFixedDropdown?: boolean;
  anchorOrigin?: PopoverOrigin;
  transformOrigin?: PopoverOrigin;
  margin?: number;
  disableRipple?: boolean;
  customIconButtonStyle?: SxProps;
  menuStyle?: SxProps;
  customMenuTextStyle?: SxProps;
  keepMounted?: boolean;
  children: React.ReactNode;
  disableButton?: boolean;
}

interface ICustomMenuItem {
  label: string | string[];
  icon?: string;
  key: string;
  onClick: (e?: React.MouseEvent<HTMLLIElement, MouseEvent>) => void;
}

const CustomMenuList = ({
  id,
  items,
  transformOrigin,
  disableRipple,
  customIconButtonStyle,
  children,
  customMenuTextStyle,
  menuStyle,
  anchorOrigin = {
    vertical: 'top',
    horizontal: 'right',
  },
  margin = 0,
  disableFixedDropdown = false,
  keepMounted = false,
  disableButton = false,
}: ICustomMenuList) => {
  const [anchorElNav, setAnchorElNav] = React.useState<HTMLButtonElement | null>(null);

  // to do change this type
  const handleOpenMenu = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    event?.stopPropagation();
    setAnchorElNav(event?.currentTarget);
  };

  const handleCloseMenu = (e: any) => {
    e?.stopPropagation();
    setAnchorElNav(null);
  };

  return (
    <Box sx={classes.customMenuContainer} component="div">
      <IconButton
        id={id}
        size="small"
        sx={customIconButtonStyle}
        onClick={handleOpenMenu}
        disableRipple={disableRipple}
        disabled={disableButton}
      >
        {children}
      </IconButton>
      <Menu
        sx={menuStyle ?? classes.customMenu}
        id="menu-appbar"
        anchorEl={anchorElNav}
        marginThreshold={margin}
        style={
          disableFixedDropdown
            ? {}
            : (genericClasses.fixedDropdown as React.CSSProperties)
        }
        keepMounted={keepMounted}
        transformOrigin={transformOrigin}
        anchorOrigin={anchorOrigin}
        open={Boolean(anchorElNav)}
        onClose={handleCloseMenu}
      >
        {items.map((item) =>
          (
            <MenuItem
              key={item.key}
              onClick={(e) => {
                item.onClick(e);
                handleCloseMenu(e);
              }}
            >
              {item.icon && (
              <Box
                sx={classes.customMenuItemIcon}
                component="img"
                src={item.icon}
              />
              )}
              <Typography
                sx={
                [
                  classes.customMenuItemLabel,
                  customMenuTextStyle,
                ] as SxProps<Theme>
              }
              >
                {item.label}
              </Typography>
            </MenuItem>
          ))}
      </Menu>
    </Box>
  );
};

export default CustomMenuList;
